@let sectionsWithNumberedFields = sectionsWithNumberedFieldsSg();
@let fields = fieldsSg();

<div class="atn-mosaic-survey">
  @if (sectionsWithNumberedFields.length) {
    @for (section of sectionsWithNumberedFields; track $index) {
      <atn-ds-section [name]="section.name">
        <atn-widget-fields
          [fields]="section.fields"
          [isOrdered]="true"
          [startFrom]="section.startFrom"
        />
      </atn-ds-section>
    }
  } @else {
    <atn-widget-fields
      [fields]="fields"
      [isOrdered]="true"
    />
  }
</div>
